import { PageTitle } from '@optools/components/layout/typography';
import { PageLoader } from '@optools/components/loading/page-loader';
import { FilteredSearch } from '@optools/components/search/filtered-search';
import { Separator } from '@optools/components/ui/separator';
import { Team } from '@optools/services/statsapi/types';
import { useTeamsQuery } from '@optools/store/statsApiSlice';
import { PipelineInputConfigsSheet } from '@optools/tools/btc-tools/components/pipeline-input-configs-sheet';
import {
  TeamConfigCard,
  TeamConfigGrid,
} from '@optools/tools/btc-tools/components/team-config-card';
import { filterTeamsBySearchTerm } from '@optools/utils/filter';
import { createFileRoute } from '@tanstack/react-router';
import { Building } from 'lucide-react';
import { useState } from 'react';

export const Route = createFileRoute('/_auth/btc-tools/configs/pipeline-input')({
  component: RouteComponent,
});

export function RouteComponent() {
  const { data = [], error, isLoading } = useTeamsQuery();
  const [currentTeam, setCurrentTeam] = useState<Team | null>(null);
  const [open, setOpen] = useState(false);

  if (isLoading) return <PageLoader />;

  if (error) {
    return (
      <section>
        <p className="mb-2">An error occurred while fetching the venues. Please try again</p>
        <p>Error: {(error as Error)?.message}</p>
      </section>
    );
  }

  const handleSelectTeam = (team: Team) => {
    setCurrentTeam(team);
    setOpen(true);
  };

  const teams = data.map((team) => ({ team }));

  return (
    <div className="space-y-4">
      <PageTitle>Pipeline Input Configs</PageTitle>
      <FilteredSearch
        data={teams}
        filterFn={filterTeamsBySearchTerm}
        placeholder="Search team or venue names">
        {(filteredTeams) => (
          <TeamConfigGrid>
            {filteredTeams.map(({ team }) => {
              const { id, venue } = team;
              return (
                <button key={id} className="group text-left" onClick={() => handleSelectTeam(team)}>
                  <TeamConfigCard
                    className="h-full transition-colors group-hover:bg-muted"
                    team={team}
                    teamId={team.id}>
                    <Separator className="my-4" />
                    <div className="flex items-center justify-between gap-4">
                      <h2 className="flex items-center gap-1 text-sm">
                        <Building className="size-4" />
                        Venue
                      </h2>
                      <p className="text-right text-xs">{venue.name}</p>
                    </div>
                  </TeamConfigCard>
                </button>
              );
            })}
          </TeamConfigGrid>
        )}
      </FilteredSearch>

      <PipelineInputConfigsSheet open={open} team={currentTeam} onOpenChange={setOpen} />
    </div>
  );
}
